import { BackgroundCheckStatus } from '@/backend/features/background-check/types';
import { FormViewer } from '@juvare/common-form-ui/FormViewer';
import { Divider, Typography } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ManualBackgroundCheckStatusSelectProps {
    backgroundCheckStatus: string | undefined;
    backgroundCheckType: string | undefined;
    setBackgroundCheckStatus: (status: BackgroundCheckStatus) => void;
}

const getManualBackgroundCheckStatusFormConfig = (t: TFunction) => ({
    type: 'form',
    children: [
        {
            type: 'form.select',
            key: 'status',
            label: t('backgroundCheck.labels.backgroundCheckStatus'),
            validate: {
                required: true,
            },
            valueProvider: {
                type: 'backgroundCheckEnabledStatuses',
                paramsFromFormData: 'type',
            },
            allowInvalidValues: true,
        },
    ],
});

export const ManualBackgroundCheckStatusSelect: React.FC<ManualBackgroundCheckStatusSelectProps> = ({
    backgroundCheckStatus,
    backgroundCheckType,
    setBackgroundCheckStatus,
}) => {
    const { t } = useTranslation();

    if (backgroundCheckType === 'manual') {
        return (
            <>
                <Divider sx={{ mt: 2 }} />
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: 14,
                        my: 2,
                    }}
                >
                    {t('backgroundCheck.messages.chooseManualBackgroundCheckStatus')}
                </Typography>
                <FormViewer
                    config={getManualBackgroundCheckStatusFormConfig(t)}
                    data={{
                        type: backgroundCheckType,
                        status: backgroundCheckStatus,
                    }}
                    onDataChange={(newData) => {
                        setBackgroundCheckStatus(newData.data.status);
                    }}
                />
            </>
        );
    }
    return;
};
